<template>
  <div>
    <v-card>
      <v-card-title>Sub Setting 3</v-card-title>
      <v-card-text>
        <p>This is the demo page for Sub Setting 3.</p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SubSetting3',
}
</script>
